
  document.addEventListener('DOMContentLoaded', function () {
    var scrollContainer = document.getElementById('latest-videos');
    var leftBtn = document.getElementById('youtube-carousel_scroll-left');
    var rightBtn = document.getElementById('youtube-carousel_scroll-right');

    // Disable left button initially
    leftBtn.disabled = true;

    // Function to get full width (including margins) of first child
    function getScrollAmount() {
      var firstChild = scrollContainer.children[0];
      if (!firstChild) {
        return 300; // fallback
      }
      var style = window.getComputedStyle(firstChild);
      var width = firstChild.offsetWidth;
      var marginLeft = parseFloat(style.marginLeft) || 0;
      var marginRight = parseFloat(style.marginRight) || 0;
      return width + marginLeft + marginRight;
    }

    // Function to update button disabled state
    function updateButtonState() {
      var scrollLeft = scrollContainer.scrollLeft;
      var maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

      leftBtn.disabled = scrollLeft <= 0;
      rightBtn.disabled = scrollLeft >= (maxScrollLeft - 1);
    }

    leftBtn.addEventListener('click', function () {
      var scrollAmount = getScrollAmount();
      scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    rightBtn.addEventListener('click', function () {
      var scrollAmount = getScrollAmount();
      scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    // Update buttons when user scrolls manually
    scrollContainer.addEventListener('scroll', updateButtonState);

    // Initial check after DOM ready and layout stable
    setTimeout(updateButtonState, 200);
  });
